import styled from '@emotion/styled';
import { N0, N300, Y200 } from '../../../../components/Colors/index';

export const HeaderUpper = styled.div`
  @media screen and (max-width: 4000px) {
    padding: 20px 52px 10px 52px;
    .first {
      font-size: 30px;
    }
    .second {
      font-size: 23px;
    }
  }
  @media screen and (max-width: 700px) {
    padding: 30px 20px 19px 20px;
    .first {
      font-size: 18px;
    }
    .second {
      font-size: 16px;
    }
  }
  background-color: ${N300};
  color: ${N0};
  font-family: "Roboto", sans-serif;
`;

export const HeaderLower = styled.div`
  padding-bottom: 15px;
  background-color: ${Y200};
`;
